import { useEffect } from "react";

import { Divider } from "@mui/material";

import Welcome from "./Welcome";
import { useAuth } from "components/auth/AuthProvider";
import { Projects } from "components/projects/Projects";
import ProtectedRoute from "components/auth/ProtectedRoute";
import { ProjectDetail } from "components/projects/Detail";
import { RequestsPendingLite } from "components/requests/PendingLite";

export const Dashboard = () => {
  const { user } = useAuth();
  const connected = user.project.connected;
  const isApprover = user.role === "admin" || user.role === "approver";

  useEffect(() => {
    document.title = "GRACE | home";
  }, []); // run once on mount

  return (
    <ProtectedRoute>
      <Welcome user={user} />

      {isApprover && <RequestsPendingLite />}
      {isApprover && <Divider />}

      {connected ? <ProjectDetail collapsible /> : <Projects collapsible />}
    </ProtectedRoute>
  );
};
